import React, { useState } from 'react';
import axios from 'axios';

function VendorRate() {
  const [pincode, setPincode] = useState('');
  const [rates, setRates] = useState([]);
  const [meta, setMeta] = useState({ destination: '', zone: '', oda: null });

  const handleSearch = async () => {
    try {
      const res = await axios.get(`http://localhost:2600/getVendorRatesByPincode?pincode=${pincode}`);
      const result = res.data.data;

      if (result.length > 0) {
        const zoneInfo = {
          destination: result[0].Destination,
          zone: result[0].Zone,
          oda: result[0].ODA_Available,
        };

        setMeta(zoneInfo);
        setRates(result);
      } else {
        setMeta({ destination: '', zone: '', oda: null });
        setRates([]);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setRates([]);
      setMeta({ destination: '', zone: '', oda: null });
    }
  };

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h2 className="text-xl font-bold mb-4">Vendor Rate Lookup by Pincode</h2>

      <div className="mb-4 flex gap-2">
        <input
          type="text"
          placeholder="Enter Pincode"
          value={pincode}
          onChange={(e) => setPincode(e.target.value)}
          className="border px-3 py-2 rounded w-60"
        />
        <button onClick={handleSearch} className="bg-blue-600 text-white px-4 py-2 rounded">
          Search
        </button>
      </div>

      {meta.destination && (
        <div className="mb-4 text-sm text-gray-700">
          <p><strong>Destination:</strong> {meta.destination}</p>
          <p><strong>Zone:</strong> {meta.zone}</p>
          <p><strong>ODA Service:</strong> {meta.oda ? 'Available' : 'Not Available'}</p>
        </div>
      )}

      {rates.length > 0 && (
        <table className="w-full border-collapse border text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-2 py-1">Vendor</th>
              <th className="border px-2 py-1">Weight</th>
              <th className="border px-2 py-1">Rate Type</th>
              <th className="border px-2 py-1">Rate (₹)</th>
            </tr>
          </thead>
          <tbody>
            {rates.map((row, idx) => (
              <tr key={idx}>
                <td className="border px-2 py-1">{row.VendorName}</td>
                <td className="border px-2 py-1">{row.Weight}</td>
                <td className="border px-2 py-1">{row.RateType}</td>
                <td className="border px-2 py-1">{row.Rate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {rates.length === 0 && meta.destination === '' && (
        <p className="text-gray-500">No data found for this pincode.</p>
      )}
    </div>
  );
}

export default VendorRate;
